import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import PropertiesPanel from './PropertiesPanel';

function QuestionSettingsModal({
    open,
    question,
    threatAreaOptions,
    threatAreasCatalog,
    onClose,
    onUpdateQuestion,
}) {
    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle sx={{ pr: 6 }}>
                Question properties
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{ position: 'absolute', right: 8, top: 8 }}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent dividers>
                <PropertiesPanel
                    variant="question-only"
                    question={question}
                    threatAreaOptions={threatAreaOptions}
                    threatAreasCatalog={threatAreasCatalog}
                    onUpdateQuestion={onUpdateQuestion}
                />
            </DialogContent>
        </Dialog>
    );
}

export default QuestionSettingsModal;
